import { AppService } from '../../app.service'
import { LoggerService, StandaloneTokenService, requireDefined } from '@agroone-front/shared'
import { StandaloneTokenNextStep, StandaloneTokenResponseDto } from '@agroone/entities'
import { Component, OnInit, inject } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { BndLoading } from '@bonduelle-it/storybook'
import { firstValueFrom } from 'rxjs'

@Component({
  selector: 'app-token-redirect',
  imports: [BndLoading],
  templateUrl: './token-redirect.component.html',
})
export class TokenRedirectComponent implements OnInit {
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private logger = inject(LoggerService)
  private standaloneTokenService = inject(StandaloneTokenService)
  private appService = inject(AppService)

  async ngOnInit(): Promise<void> {
    const token = this.route.snapshot.queryParamMap.get('token')
    if (!token) {
      this.logger.error('No token found in URL')
      this.router.navigate(['/logout'])
      return
    }
    try {
      const tokenInfos: StandaloneTokenResponseDto = await firstValueFrom(this.standaloneTokenService.getTokenInfos())
      this.appService.setIsLimitedApplication(tokenInfos.isLimitedApplication)
      if (tokenInfos.nextStep === StandaloneTokenNextStep.FARM_CSR_EDIT) {
        this.router.navigate([
          `/crop-management/farm/${requireDefined(tokenInfos.nextStepMetadata, 'the token infos next step metadata').farmId}/csr`,
        ])
      } else {
        this.router.navigate(['/logout'])
      }
    } catch (error) {
      this.logger.error('Error getting token infos', error)
      this.router.navigate(['/logout'])
    }
  }
}
